/**
 * 解决滚动穿透问题
 */
import { isServer } from "@/lib/commonService";

let scrollY = undefined;

export function fixBody() {
    if (!isServer) {
        scrollY = window.scrollY;
        // document.body.style.left = '0';
        // document.body.style.right = '0';
        // document.body.style.top = -scrollY + 'px';
        // document.body.style.position = 'fixed';
        document.body.style.overflow = "hidden";
    }
}

export function cancelFixBody() {
    if (isServer || scrollY === undefined) {
        return;
    }
    // document.body.style.left = 'initial';
    // document.body.style.right = 'initial';
    // document.body.style.top = 'initial';
    // document.body.style.position = 'initial';
    document.body.style.overflow = "initial";
    window.scrollTo(0, scrollY);
}
